import floorwalkLogo from "../../../img/logo_500x268.png";
import floorwalkSmallLogo from "../../../img/logo_200x120.png";
import hsBrandsLogo from "../../../img/hs_brand_logo.png";
import fw_favicon from "../../../img/favicon.png";
import hsbrand_favicon from "../../../img/hsbrand_favicon.png";

const tenants = {
  floorwalk: {
    name: "FloorWalk",
    fullName: "FloorWalk Consultants Pvt. Ltd.",
    loginLogo: floorwalkSmallLogo,
    logo: floorwalkLogo,
    footerLogo: floorwalkLogo,
    favicon: fw_favicon,
    baseUrl: "https://portal.floorwalk.in/",
    colors: {
      "--common-color": "#003c5d",
      "--blue-shade": "#007dc1",
    },
  },

  hsbrandsasia: {
    name: "HS Brands Asia",
    fullName: "HS Brands Private Limited",
    loginLogo: hsBrandsLogo,
    logo: hsBrandsLogo,
    footerLogo: hsBrandsLogo,
    favicon: hsbrand_favicon,
    baseUrl: "https://portal.hsbrandsasia.com/",
    colors: {
      "--common-color": "#8f061e",
      "--blue-shade": "#0f1d38",
    },
  },
};

export default tenants;